/**
 * webRTCConnectionReducer.js
 * Talkroute
 *
 * Created by Vel Genov on 11/6/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */
import { REHYDRATE } from "redux-persist";

import {
  CONNECTION_DATA_FETCH_STARTED,
  CONNECTION_DATA_FETCH_SUCCESS,
  CONNECTION_DATA_FETCH_FAILURE,
} from "../actions/webRTCConnectionActions";
import { CLEAR_ERRORS } from "@actions/errorActions";
import dataStateEnum from "../constants/dataStateConstants";

export interface IWebRTCConnectionReducer {
  realm: null | string;
  impi: null | string;
  impu: null | string;
  password: null | string;
  displayName: null | string;
  webSocketProxyUrl: null | string;
  dataState: dataStateEnum;
  error: null | string;
}

const initialState = {
  realm: null,
  impi: null,
  impu: null,
  password: null,
  displayName: null,
  webSocketProxyUrl: null,
  dataState: dataStateEnum.LOADING,
  error: null,
};

/**
 * Called to process authentication actions
 *
 * @param {*} state
 * @param {*} action
 */
export default function webRTCConnection(state: IWebRTCConnectionReducer = initialState, action): IWebRTCConnectionReducer {
  switch (action.type) {
    case REHYDRATE: {
      // A redux-persist action. Called immediately after launch.
      const { payload } = action;
      if (payload) {
        const {
          realm,
          impi,
          impu,
          password,
          displayName,
          webSocketProxyUrl,
        } = payload.webRTCConnection;

        return {
          ...state,
          realm,
          impi,
          impu,
          password,
          displayName,
          webSocketProxyUrl,
          error: null,
        };
      }

      return {
        ...state,
      };
    }
    case CONNECTION_DATA_FETCH_STARTED:
      // Started fetching connection data
      return {
        ...state,
        dataState: dataStateEnum.LOADING,
        error: null,
      };
    case CONNECTION_DATA_FETCH_SUCCESS: {
      // Success fetching connection data
      const { payload } = action;
      if (payload) {
        const { data } = payload;
        if (data) {
          const {
            realm,
            impi,
            impu,
            password,
            displayName,
            webSocketProxyUrl,
          } = data;

          return {
            ...state,
            realm,
            impi,
            impu,
            password,
            displayName,
            webSocketProxyUrl,
            dataState: dataStateEnum.READY,
            error: null,
          };
        }
      }
      return {
        ...state,
      };
    }
    case CONNECTION_DATA_FETCH_FAILURE: {
      // Failure fetching connection data
      const { payload } = action;
      if (payload) {
        return {
          ...state,
          dataState: dataStateEnum.ERROR,
          error: payload.error,
        };
      }

      return {
        ...state,
        dataState: dataStateEnum.ERROR,
      };
    }
    case CLEAR_ERRORS:
      // Clear any errors
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
}
